import { object, string, z } from "zod";

export const loginSchema = object({
  email: string({ required_error: "Email is required" }).email(
    "Email is invalid"
  ),
  password: string({ required_error: "Password is required" })
    .min(6, "Password must be more than 6 characters")
    .max(32, "Password must be less than 32 characters"),
});

export const otpcodeSchema = object({
  code: string({ required_error: "OTP code is required" }).min(
    5,
    "Enter complete OTP"
  ),
});

export const forgotPasswordSchemaOne = object({
  email: string({ required_error: "Email is required" }).email(
    "Email is invalid"
  ),
});
export const forgotPasswordSchemaTwo = object({
  code: string({ required_error: "OTP code is required" }).min(
    5,
    "Enter complete OTP"
  ),
});

export const passwordSchema = object({
  password: string({ required_error: "Password is required" })
    .min(6, "Password must be more than 6 characters")
    .max(32, "Password must be less than 32 characters")
    .regex(/^(?=.*[A-Z])(?=.*\d).*$/, {
      message:
        "Password must contain at least one uppercase letter and one numeric digit",
    }),
  passwordConfirm: string({ required_error: "Please confirm your password" }),
}).refine((data) => data.password === data.passwordConfirm, {
  path: ["passwordConfirm"],
  message: "Passwords do not match",
});
